import React, { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { useProfile } from "../hooks/index";
import { Utils } from "helpers/utils";

interface AuthProtectedProps {
  routeName: string;
}

//const AuthProtected = (props: any) => {
const AuthProtected = ({ routeName, children }: PropsWithChildren<AuthProtectedProps>) => {
  const { userProfile, loading } = useProfile();

  if (userProfile == null) {
    const keys = Utils.GetAllLocalStorageKey();
    Utils.LogDb(`No authUser calling from AuthProtected[${routeName}], then go login [local key = ${keys}]`, 1, "AuthProtected", Utils.GetDeviceId());
  }

  /*
    redirect is un-auth access protected routes via url
  */
  if (!userProfile && loading) {
    return (
      // <Navigate to={{ pathname: "/auth-login"}} />
      <Navigate to={{ pathname: "/auth-login" }} />
    );
  }

  //return <>{props.children}</>;
  return <>{children}</>;
};

export { AuthProtected };
